// import protoRoot from "../proto-root";
import createMessage from "./createMessage";
import MotionDetectorState from "../private/MotionDetectorState";

const name = "motionDetectorState";

function create({ state }) {
  return createMessage({
    [name]: MotionDetectorState.create(state)
  });
}
export default {
  create,
  name
};

// message MotionDetectorState {
//     enum DetectorStateType {
//         UNKNOWN = 0;

//         RUNNING = 1;
//         // means no need to run - motion detection is not enabled by user
//         NOT_RUNNING = 2;

//         STOPPED_REASON_LOW_CAMERA_EXPOSURE = 10;
//         STOPPED_REASON_LYING_DEVICE = 11;
//         STOPPED_REASON_FLASHLIGHT_ACTIVE = 12;

//     }

//     DetectorStateType state = 1;
// }
